import React, { useState } from "react";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Input, Button, message, Spin } from "antd";
import "antd/dist/antd.css";
const { TextArea } = Input;
const base_url =
  process.env.LIVE_SERVER || "https://black-box-server.herokuapp.com";
function Contact(props) {
  const [componentDisabled, setComponentDisabled] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required().label("Name"),
    email: Yup.string().required().email().label("Email"),
    subject: Yup.string().required().label("Subject"),
    message: Yup.string().required().label("Message"),
  });
  const onFormLayoutChange = ({ disabled }) => {
    setComponentDisabled(disabled);
  };
  const sendRequest = (formData) => {
    setSpinner(true);
    axios
      .post(`${base_url}/post-request`, {
        Name: formData.name,
        Email: formData.email,
        Subject: formData.subject,
        Message: formData.message,
      })
      .then((response) => {
        if (response.data.warn) {
          message.warn(response.data.warn);
          setSpinner(false);
        }
        if (response.data.message) {
          message.success(response.data.message);
          setSpinner(false);
          window.location.reload();
        }
        if (response.data.error) {
          message.error(response.data.error);
          setSpinner(false);
        }
      });
  };
  return (
    <section id="contact" class="contact">
      <div class="container">
        <div class="section-title">
          <span>Contact</span>
          <h2>Contact</h2>
          <p>If you have any query, Please do not hasitate to contact us.</p>
        </div>

        <div class="row" data-aos="fade-up">
          <div class="col-lg-6">
            <div class="info-box mb-4">
              <i class="bx bx-map"></i>
              <h3>Our Address</h3>
              <a
                href="map:1002, Kabul Afghanistan"
                style={{ color: "#cc1616" }}
              >
                {" "}
                1002, Kabul, Afghanistan
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="info-box  mb-4">
              <i class="bx bx-envelope"></i>
              <h3>Email Us</h3>
              <a
                href="mailto:qanoonisuhaib@aol.com"
                style={{ color: "#cc1616" }}
              >
                qanoonisuhaib@aol.com
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="info-box  mb-4">
              <i class="bx bx-phone-call"></i>
              <h3>Call Us</h3>
              <a href="callto:+93786702440" style={{ color: "#cc1616" }}>
                {" "}
                +93 786 702 440
              </a>
            </div>
          </div>
        </div>

        <div class="row" data-aos="fade-up">
          <div class="col-lg-6 ">
            <iframe
              class="mb-4 mb-lg-0"
              src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=1002, kabul Afghanistan&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              frameborder="0"
              style={{ borderWidth: 0, width: "100%", height: 410 }}
              allowfullscreen
            ></iframe>
          </div>

          <div class="col-lg-6">
            <p style={{ color: "#cc1616" }}>
              <strong>Note: </strong>Please be conscious while filling the form,
              because you can fill the form only once.
            </p>
            <Formik
              initialValues={{
                name: "",
                email: "",
                subject: "",
                message: "",
              }}
              onSubmit={(formData) => {
                sendRequest(formData);
              }}
              validationSchema={validationSchema}
            >
              {({ errors, touched, handleChange, handleSubmit }) => (
                <Form
                  size="large"
                  labelCol={{
                    span: 0,
                  }}
                  wrapperCol={{
                    span: 24,
                  }}
                  layout="horizontal"
                  onValuesChange={onFormLayoutChange}
                  disabled={componentDisabled}
                >
                  <Form.Item>
                    <abbr title="Fill Your Name">
                      <Input
                        placeholder="Full Name"
                        onChange={handleChange("name")}
                      />
                    </abbr>
                    {touched.name && (
                      <p style={{ color: "red" }}>{errors.name}</p>
                    )}
                  </Form.Item>
                  <Form.Item>
                    <abbr title="Fill Your Email">
                      <Input
                        placeholder="Email"
                        type="email"
                        onChange={handleChange("email")}
                      />
                    </abbr>
                    {touched.email && (
                      <p style={{ color: "red" }}>{errors.email}</p>
                    )}
                  </Form.Item>
                  <Form.Item>
                    <abbr title="Subject: eg, Course Registeration or Project Hiring">
                      <Input
                        placeholder="Subject"
                        onChange={handleChange("subject")}
                      />
                    </abbr>
                    {touched.subject && (
                      <p style={{ color: "red" }}>{errors.subject}</p>
                    )}
                  </Form.Item>

                  <Form.Item>
                    <abbr title="Write Details about your subject line">
                      <TextArea
                        placeholder="Message"
                        rows={4}
                        onChange={handleChange("message")}
                      />
                    </abbr>
                    {touched.message && (
                      <p style={{ color: "red" }}>{errors.message}</p>
                    )}
                  </Form.Item>
                  <div class="text-center">
                    <Form.Item label="">
                      <Button type="danger" block onClick={handleSubmit}>
                        {" "}
                        <Spin spinning={spinner} />
                        Submit
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
